import { Link } from 'react-router-dom';
import styled from 'styled-components';
import _default from '../../themes/default';


//background-color: ${({theme}) => theme.card_light};
// background-color : transparent;
// background: rgba(255, 255, 255, 0.1); /* Light semi-transparent background */
/*
backdrop-filter: blur(5px); 
-webkit-backdrop-filter: blur(10px);

justify-content: left;

*/
// Main Container
export const Nav = styled.div`
    
  display: flex;
  align-items: center;
  
  position: sticky;
  top: 0;
  z-index: 10;

  height: 80px;

  background-color: ${({theme}) => theme.card_light};

  font-size: 1rem;
  
  @media (max-width: 960px) {
      trastion: 0.8s all ease;
  }

  transition : 0.3s;
    
`;

// align-items: center;
// z-index: 1;
// max-width: 1200px; 
// justify-content: ${(props) => props.justifyContent || 'left'};
// Container for Left and Right Part of the Navbar
export const NavbarContainer = styled.div`

  display: flex;
  
  height: 60px;

  padding: 0 24px;
  margin-left: ${(props) => props.marginLeft || '0px'};
  
`;


// width: 100%;
// padding: 0 6px;

// width: 80%;   
/*
img {
        width: 40px; 
        height: auto;
        margin-right: 10px; 
    }

  .icon {
        font-size: 24px; 
        margin-left: 10px; 
    }

    @media (max-width: 640px) {
        padding: 0 0px;
    }

    
    justify-content: start;
    
  display: flex;
  align-items: center;

  color: ${({theme}) => theme.text_primary};  
  font-weight: bold;
  font-size: 18px; 

 */
// Logo Navigation    
export const ClubLogo = styled.img`
`;

export const NavItems = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.8em;
  padding: 0 6px;
  list-style: none;
  white-space: nowrap;
  
  @media screen and (max-width: 768px) {
    display: none;
  }

`;

export const NavLink = styled.a`
    color: ${({ theme }) => theme.text_primary};
    
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
     transform-origin: center;
    :hover {
      color: ${({ theme }) => theme.primary};
       transform: scale(1.1);

    }

    &.active {
      border-bottom: 2px solid ${({ theme }) => theme.primary};
    }
`;
export const ButtonContainer = styled.div`
  width: 80%;  
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 6px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

// Menu Icon
export const MobileIcon = styled.div`
  display: none;
  
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.5rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text_primary};
  }
`
export const MobileIconsContainer = styled.div`
    @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: row;
        justify-content: flex-start; 
        align-items: center; 
        width: 100%;
        gap: 1px;
    }
`;

export const MobileMenu = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    position: absolute;
    top: 80px;
    right: 0;
    width: 100%;
    padding: 12px 40px 24px 40px;
    background: ${({ theme }) => theme.card_light+99};
    transition: all 0.6s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-100%)')};
    border-radius: 0 0 20px 20px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    z-index: ${({ isOpen }) => (isOpen ? '1000' : '-1000')};

`
export const MobileMenuItems = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  list-style: none;
  width: 100%;
  height: 100%;
`
export const MobileMenuLink = styled(Link)`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }

  &.active {
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
`;

export const MobileMenuButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;
  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.6s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }
`;

export  const MobileLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }

  &.active {
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
`;